import {
  ExtensionLoginButton,
  LedgerLoginButton,
  WalletConnectLoginButton,
  WebWalletLoginButton,
} from "@/components";
import { useCallback, useEffect } from "react";
import { useGetAccount, useGetLoginInfo } from "@/hooks";
import { logout } from "@multiversx/sdk-dapp/utils";

export const ConnectWalletProvider = () => {
  const { address } = useGetAccount();
  const { tokenLogin } = useGetLoginInfo();

  // Define login handlers
  const handleXPortalLogin = useCallback(() => {
    const container = document.getElementById("xportal-login");
    const button = container?.querySelector("button");
    if (button) button.click();
  }, []);

  const handleWebWalletLogin = useCallback(() => {
    const container = document.getElementById("webwallet-login");
    const button = container?.querySelector("button");
    if (button) button.click();
  }, []);

  const handleDeFiWalletLogin = useCallback(() => {
    const container = document.getElementById("defiwallet-login");
    const button = container?.querySelector("button");
    if (button) button.click();
  }, []);

  const handleLedgerLogin = useCallback(() => {
    const container = document.getElementById("ledger-login");
    const button = container?.querySelector("button");
    if (button) button.click();
  }, []);

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  useEffect(() => {
    if (!addEventListener || !removeEventListener) return;

    const eventHandlers = {
      XPortalLogin: handleXPortalLogin,
      WebWalletLogin: handleWebWalletLogin,
      DefiWalletLogin: handleDeFiWalletLogin,
      LedgerLogin: handleLedgerLogin,
      Logout: handleLogout,
    };

    Object.entries(eventHandlers).forEach(([event, handler]) => {
      addEventListener(event, handler);
    });

    return () => {
      Object.entries(eventHandlers).forEach(([event, handler]) => {
        removeEventListener(event, handler);
      });
    };
  }, [
    addEventListener,
    removeEventListener,
    handleXPortalLogin,
    handleWebWalletLogin,
    handleDeFiWalletLogin,
    handleLedgerLogin,
    handleLogout,
  ]);

  return (
    <div className="hidden">
      <div id="xportal-login">
        <WalletConnectLoginButton nativeAuth />
      </div>
      <div id="webwallet-login">
        <WebWalletLoginButton nativeAuth />
      </div>
      <div id="defiwallet-login">
        <ExtensionLoginButton nativeAuth />
      </div>
      <div id="ledger-login">
        <LedgerLoginButton nativeAuth />
      </div>
    </div>
  );
};
